import axios from 'axios'

export const BurialService = {
    loadBurial: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/my-funeral/burial')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    saveBurial: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/my-funeral/burial', payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/services/burial-service.js